import { t } from '../composables/useText.js';

export const DIFFICULTY_LEVELS = [
  { value: 'easy', label: t('form.difficulty-easy') },
  { value: 'medium', label: t('form.difficulty-medium') },
  { value: 'hard', label: t('form.difficulty-hard') }
];

const HARD_MIN_GAMES = 1;

export const DIFFICULTY_GAME_LIMITS = {
  mediumMin: 6,
  easyMin: 20
};

export const DIFFICULTY_GAME_RANGES = {
  easy: { min: DIFFICULTY_GAME_LIMITS.easyMin, max: null },
  medium: {
    min: DIFFICULTY_GAME_LIMITS.mediumMin,
    max: DIFFICULTY_GAME_LIMITS.easyMin - 1
  },
  hard: {
    min: HARD_MIN_GAMES,
    max: DIFFICULTY_GAME_LIMITS.mediumMin - 1
  }
};

export const getDifficultyGameRange = (level) => {
  return DIFFICULTY_GAME_RANGES[level] ?? DIFFICULTY_GAME_RANGES.easy;
};

export const getDifficultyRangeLabel = (level) => {
  const range = getDifficultyGameRange(level);
  if (range.max == null) {
    return `${range.min}+ ${t('form.difficulty-games-suffix')}`;
  }
  return `${range.min}-${range.max} ${t('form.difficulty-games-suffix')}`;
};

export const SEASON_VISIBILITY = {
  all: 'all',
  upToSelected: 'upToSelected',
  selectedOnly: 'selectedOnly'
};

export const DIFFICULTY_FEATURES = {
  easy: {
    seasonVisibility: SEASON_VISIBILITY.all,
    enableSeasonReveal: false
  },
  medium: {
    seasonVisibility: SEASON_VISIBILITY.all,
    enableSeasonReveal: false
  },
  hard: {
    seasonVisibility: SEASON_VISIBILITY.all,
    enableSeasonReveal: false
  }
};

export const getDifficultyFeatures = (level) => {
  return DIFFICULTY_FEATURES[level] ?? DIFFICULTY_FEATURES.easy;
};

export const getInitialSeasonYears = (seasonYears, selectedYear, visibility) => {
  const sortedSeasons = [...seasonYears].sort((a, b) => a - b);

  switch (visibility) {
    case SEASON_VISIBILITY.upToSelected:
      return sortedSeasons.filter((year) => year <= selectedYear);
    case SEASON_VISIBILITY.selectedOnly:
      return sortedSeasons.includes(selectedYear) ? [selectedYear] : [];
    case SEASON_VISIBILITY.all:
    default:
      return sortedSeasons;
  }
};
